module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kc-Ld.619599d5.png";